import { Notify } from "@/components/ui/notify";
import { useLineMachines } from "@/features/lines/hooks";
import { useLineCanvas } from "./hooks";

interface Props {
  lineId: string;
}

export function OrphanMachinesBanner({ lineId }: Props) {
  const { data: machines = [] } = useLineMachines(lineId, 30_000);
  const { data: canvas } = useLineCanvas(lineId);

  if (!canvas) return null;

  const linkedMachineIds = new Set(
    canvas.nodes
      .filter((n) => n.type === "MACHINE" && typeof n.data?.machineId === "string")
      .map((n) => n.data.machineId as string)
  );
  const orphans = machines.filter((m) => !linkedMachineIds.has(m.id));
  if (orphans.length === 0) return null;

  const title =
    orphans.length === 1
      ? "1 máquina cadastrada sem representação no canvas — adicione via toolbar."
      : `${orphans.length} máquinas cadastradas sem representação no canvas — adicione via toolbar.`;

  return <Notify.Banner variant="warning" title={title} />;
}
